import { render, staticRenderFns } from "./myNewOrder.vue?vue&type=template&id=316b0e5f&scoped=true&"
import script from "./myNewOrder.vue?vue&type=script&lang=js&"
export * from "./myNewOrder.vue?vue&type=script&lang=js&"
import style0 from "./myNewOrder.vue?vue&type=style&index=0&id=316b0e5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316b0e5f",
  null
  
)

export default component.exports